import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import GeneralInfoEntry from "../../panels/generalInfo/components/GeneralInfoEntry";
import Typography from "components/Typography";
import OfferInput from "./inputs/OfferInput";


function OfferPositionConditions(
    {
        formikProps,
        conditions,
        priceType,
        disabled
    }) {

    return (
        <GeneralInfoEntry biggerLabel label={Tr('conditions')} collapsible defaultCollapsed={false}>
            {
                conditions.length === 0 ?
                    <Typography>{Tr('conditions_specifed_in_SIWZ_offer_form')}</Typography>
                    :
                    conditions.map((condition, index) => (
                        <OfferInput
                            key={condition.criterium.identity}
                            id={`conditions.${index}`}
                            criterion={condition}
                            formikProps={formikProps}
                            priceType={priceType}
                            disabled={disabled}
                        />
                    ))}
        </GeneralInfoEntry>)

}

OfferPositionConditions.propTypes = {
    conditions: PropTypes.array.isRequired
}

export default OfferPositionConditions;